import { render, staticRenderFns } from "./recordTable.vue?vue&type=template&id=45b50a5a&scoped=true"
import script from "./recordTable.vue?vue&type=script&lang=js"
export * from "./recordTable.vue?vue&type=script&lang=js"
import style0 from "./recordTable.vue?vue&type=style&index=0&id=45b50a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b50a5a",
  null
  
)

export default component.exports